import { MediaQueries } from "components/responsive";
import { getIconData } from "pages/partview/utils/exceptions.utils";
import { PackageStatusOption } from "pages/partview/utils/filter.utils";
import moment from "moment";

export const PartViewDashboardWidgetStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  [MediaQueries.mediumAndUp]: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  "@media (min-width: 1500px)": {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  "@media (min-width: 2100px)": {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  "@media (min-width: 3300px)": {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
  },
};

export const getPackageStat = (counts, handler, t) => {
  return {
    title: t("partview-dashboard:Delivered in last 24 hours"),
    exceptions: [
      {
        name: t("partview-dashboard:Packages"),
        count: counts ?? 0,
        icon: {
          ...getIconData("Delivered"),
        },
        showNumberSeparator: false,
      },
    ],
    onClickHandler: () => handler(),
  };
};

export const getExceptionStat = (counts, handler, t) => {
  return {
    title: t("partview-dashboard:Affected by Exceptions"),
    exceptions: [
      {
        name: t("partview-dashboard:Packages"),
        count: counts ?? 0,
        icon: {
          ...getIconData("MS"),
        },
        showNumberSeparator: false,
      },
    ],
    onClickHandler: () => handler(),
  };
};

export const getExceptionCounts = (exceptionsObject) => {
  return exceptionsObject
    ? Object.entries(exceptionsObject).reduce(
        (accumulator, [key, value]) => accumulator + value,
        0,
      )
    : 0;
};

export function getSelectedActiveFilterOptions(includeAPU) {
  const result = [
    PackageStatusOption.CREATED_OR_PACKAGED,
    PackageStatusOption.IN_ROUTE,
    PackageStatusOption.DELAYED,
  ];
  if (includeAPU) {
    result.push(PackageStatusOption.AVAILABLE_FOR_PICKUP);
  }
  return result;
}

export function getPast24Hrs() {
  // Get 24 hours delivered packages count by passing the from and to date time.
  let fromDate = moment().subtract(24, "hours").utc().toISOString();
  let toDate = moment().utc().toISOString();
  return { fromDate, toDate };
}
